import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import ListingCard from "@/components/ListingCard";
import { Loading } from "@/components/auth/RequireAuth";
import { publicApi } from "@/lib/api";

export default function Lander() {
  const { key } = useParams();
  const [data, setData] = useState(null);
  const [missing, setMissing] = useState(false);
  useEffect(() => {
    setData(null);
    publicApi.get(`/landers/${key}`).then((r) => setData(r.data)).catch(() => setMissing(true));
  }, [key]);
  if (missing) return <div className="mx-auto max-w-3xl px-6 py-24"><h1 className="text-3xl">Page not found</h1><Link to="/explore" className="text-secondary">Explore all</Link></div>;
  if (!data) return <Loading />;
  return (
    <div data-testid={`lander-page-${key}`}>
      <section className="grain bg-primary text-white">
        <div className="mx-auto max-w-7xl px-5 py-20 md:px-8">
          <div className="eyebrow text-white/60">{data.kicker}</div>
          <h1 className="mt-3 text-4xl tracking-tight sm:text-5xl lg:text-6xl">{data.title}</h1>
          <p className="mt-5 max-w-2xl text-base text-white/75 md:text-lg">{data.intro}</p>
        </div>
      </section>
      <div className="mx-auto max-w-7xl px-5 py-14 md:px-8">
        {data.listings.length === 0 ? <p className="text-muted-foreground" data-testid="lander-empty">New getaways for this intent are in review. Check back soon.</p> : (
          <div className="grid gap-x-8 gap-y-12 sm:grid-cols-2 lg:grid-cols-3">
            {data.listings.map((l) => <ListingCard key={l.id} l={l} />)}
          </div>
        )}
      </div>
    </div>
  );
}
